export const sizeOptions = ['xs', 'sm', 'md', 'lg'];
